import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import ReactTooltip from 'react-tooltip';

import { Link } from 'react-router-dom';

import Select from 'react-select';

import ReviewSnapshot from '../salesCompetencies/reviewSnapshot';

import {
  getIcon,
  formatThousands,
  getPredictiveSkillsReviewScoresFromReviewData,
  getOptionValueForSelect,
} from '../../util';

import {
  fetchUserDataForEveryone
} from '../../actions';

import {
  fetchAllSalesCompetencyReviews,
  fetchSalesCompetencyReviewItems,
} from '../../actions/salesCompetencyReviews';

import {
  ScoredCriticalExpertiseItemsSelector
} from '../../selectors';

const ALL_TEAMS_OPTION = {
  value: 'everyone',
  label: 'Everyone',
}

const ENTIRE_TEAM_OPTION = {
  value: false,
  userData: null,
  label: 'Entire Team',
}

class StrengthsReport extends Component {

  state = {
    viewingTeam: 'everyone',
    userData: {},
    showingDetailsForUsers: {},
    orderingBy: 'overallScore'
  }

  componentDidMount(){
    this.props.fetchUserDataForEveryone(userData => {

      // console.log('found user data: ', userData);
      this.setState({
        userData: _.keyBy(userData, '_id')
      });
    });

    this.props.fetchAllSalesCompetencyReviews();

    if(!this.props.salesCompetencyReviewItems){
      this.props.fetchSalesCompetencyReviewItems();
    }
  }

  getScoresFromReviews(currentReview, priorReview){
    return getPredictiveSkillsReviewScoresFromReviewData(this.props.salesCompetencyReviewItems, this.props.scoredCriticalExpertiseItems, currentReview, priorReview);
  }

  filteredAndSortedReviews(){
    const reviewsBySeller = _.groupBy(this.props.salesCompetencyReviews, 'seller');

    //for each seller, first review will be current, next review will be prior
    const mappedReivews = _.map(this.state.userData, (seller, sellerId) => {

      const sellerData = this.userData(sellerId);

      const reviewsForSeller = reviewsBySeller[sellerId];

      console.log('reviews for seller: ', reviewsForSeller);

      if(!reviewsForSeller){
        return {
          sellerId,
          sellerData,
          currentReview: null,
          priorReview: null,
        }
      }

      const currentReview = reviewsForSeller[0] || null;
      const priorReview = reviewsForSeller[1] || null;

      const scores = this.getScoresFromReviews(currentReview, priorReview);

      return {
        sellerId,
        sellerData,
        currentReview,
        priorReview,
        scores,
        //other stuff... to help w/ searching / sorting
      }
    });

    const reviewsWithScores = _.filter(mappedReivews, 'scores');

    let reviewsForSelectedSellers = reviewsWithScores;

    if(this.state.viewingTeam !== 'everyone'){
      reviewsForSelectedSellers = _.filter(reviewsWithScores, item => {

        let userMatchingTeam = false;
        _.each(this.userData(item.sellerId).teams, team => {
          if(team._id === this.state.viewingTeam){
            userMatchingTeam = true;
          }
        });

        return userMatchingTeam;
      })
    }

    const sortedReviews = _.orderBy(reviewsForSelectedSellers, item => {
      return item.scores[this.state.orderingBy]
    }, 'desc');

    return sortedReviews;
  }

  viewingTeamData(){
    return _.find(this.props.teams, { _id: this.state.viewingTeam });
  }

  userData(userId){
    const dataForUser = this.state.userData[userId];

    const dataForUserWithTeams = {
      ...dataForUser,
      teams: _.filter(this.props.teams, team => {
        return team.members.indexOf(userId) !== -1 || team.leaders.indexOf(userId) !== -1;
      }),
    }

    return dataForUserWithTeams;
  }

  viewTeam(teamId){
    this.setState({
      viewingTeam: teamId,
      viewingTeamUser: false,
    });
  }

  getTeamOptions(){
    const { teams } = this.props;

    let teamOptions = [];

    _.each(teams || [], team => {
      teamOptions.push({
        value: team._id,
        label: team.name
      });
    });

    return [
      ALL_TEAMS_OPTION,
      ...teamOptions
    ]
  }

  getViewingTeamSelectValue(){
    const { viewingTeam } = this.state;

    if(viewingTeam === 'everyone'){
      return ALL_TEAMS_OPTION;
    }

    const matchingTeam = _.find(this.getTeamOptions(), team => {
      return team.value === viewingTeam._id;
    });

    return matchingTeam;
  }

  renderTeamSelect(){

    const teamOptions = this.getTeamOptions();

    if(!teamOptions || teamOptions.length === 0){
      return null;
    }

    return (
      <Select
        classNamePrefix={'react-select'}
        className='react-select-container team-select'
        value={this.getViewingTeamSelectValue()}
        options={teamOptions}
        onChange={(option) => { this.viewTeam(option.value) }}
        isSearchable={false}
      />
    );
  }

  renderOrderBySelect(){
    const orderByOptions = [
      {
        label: 'Weighted Total',
        value: 'overallScore'
      },
      {
        label: 'Selling Competencies ',
        value: 'competencyScore'
      },
      {
        label: 'Critical Expertise',
        value: 'expertiseScore'
      },
      {
        label: 'Coachability',
        value: 'coachabilityScore'
      },
      {
        label: 'Most Improved',
        value: 'overallDelta'
      },
    ];

    const { orderingBy } = this.state;

    return (
      <Select
        classNamePrefix={'react-select'}
        className={`react-select-container small-select ${orderingBy ? 'has-value' : ''}`}
        value={getOptionValueForSelect(orderByOptions, orderingBy)}
        options={orderByOptions}
        onChange={(option) => { this.setState({ orderingBy: option.value }); } }
      />
    )
  }

  getReportName(){
    if(this.viewingTeamData()){
      return `Strengths for ${this.viewingTeamData().name}`;
    }
    else{
      return 'Organization Strengths';
    }
  }

  toggleDetailsForItem(item){
    this.setState({
      showingDetailsForUsers: {
        ...this.state.showingDetailsForUsers,
        [item.sellerId]: !(this.state.showingDetailsForUsers[item.sellerId])
      }
    });
  }

  renderReportItem(item){

    const detailsToggledOn = this.state.showingDetailsForUsers[item.sellerId];

    const {
      overallScore,
      overallTier,
      overallDelta,
      competencyScore,
      competencyTier,
      competencyDelta,
      expertiseScore,
      expertiseTier,
      expertiseDelta,
      coachabilityScore,
      coachabilityTier,
      coachabilityDelta,

    } = item.scores;

    const {
      orderingBy
    } = this.state;

    const iconForOrderingBy = (orderingBy === 'overallDelta' ? 'growth' : (orderingBy === 'competencyScore' ? 'competencies' : (orderingBy === 'expertiseScore' ? 'lightbulb' : 'coachability')));

    console.log('iconForOrderingBy: ', iconForOrderingBy);

    return (
      <div
        key={item.sellerId}
        className="report-item">

        {orderingBy !== 'overallScore' &&
          <div className="ordering-by-icon">{getIcon(iconForOrderingBy)}</div>
        }
        {orderingBy === 'overallScore' &&
          <div className="overall-score">
            <div className={`dial tier-${overallTier} medium-ring`} style={{width: '60px', height: '60px'}}>
              <div className="dial__progress" data-percent={overallScore}></div>
              <div className="dial__content" style={{lineHeight: '45px', fontSize: '18px'}}>{overallScore}</div>
              {!!overallDelta &&
                <div className="diff-amount">{overallDelta > 0 ? '+' : ''}{overallDelta}</div>
              }
            </div>
          </div>
        }
        {orderingBy === 'overallDelta' &&
          <div className="overall-score">
            <div className={`dial tier-${overallTier} medium-ring`} style={{width: '60px', height: '60px'}}>
              <div className="dial__progress" data-percent={overallScore}></div>
              <div className="dial__content" style={{lineHeight: '45px', fontSize: '18px'}}>{overallScore}</div>
              <div className="diff-amount">{overallDelta > 0 ? '+' : ''}{overallDelta}</div>
            </div>
          </div>
        }
        {orderingBy === 'competencyScore' &&
          <div className="overall-score">
            <div className={`dial tier-${competencyTier} medium-ring`} style={{width: '60px', height: '60px'}}>
              <div className="dial__progress" data-percent={competencyScore}></div>
              <div className="dial__content" style={{lineHeight: '45px', fontSize: '18px'}}>{competencyScore}</div>
            </div>
          </div>
        }
        {orderingBy === 'expertiseScore' &&
          <div className="overall-score">
            <div className={`dial tier-${expertiseTier} medium-ring`} style={{width: '60px', height: '60px'}}>
              <div className="dial__progress" data-percent={expertiseScore}></div>
              <div className="dial__content" style={{lineHeight: '45px', fontSize: '18px'}}>{expertiseScore}</div>
            </div>
          </div>
        }
        {orderingBy === 'coachabilityScore' &&
          <div className="overall-score">
            <div className={`dial tier-${coachabilityTier} medium-ring`} style={{width: '60px', height: '60px'}}>
              <div className="dial__progress" data-percent={coachabilityScore}></div>
              <div className="dial__content" style={{lineHeight: '45px', fontSize: '18px'}}>{coachabilityScore}</div>
            </div>
          </div>
        }
        <div className="seller-info">
          <div className="name">{item.sellerData.firstName} {item.sellerData.lastName}</div>
          <div className="team">{_.map(item.sellerData.teams, 'name').join(', ')}</div>
        </div>
        {orderingBy === 'overallScore' &&
          <div className={`component-scores ${detailsToggledOn ? 'faded' : ''}`}>
            <div className="component-score" data-tip={`Selling Competencies Component Score: ${competencyScore}`} data-for="component-score-tooltip">
              <div className="component-icon">{getIcon('competencies')}</div>
              <div className="progress-bar">
                <div className={`progress tier-${competencyTier}-bg`} style={{width: `${competencyScore}%`}}></div>
              </div>
            </div>
            <div className="component-score" data-tip={`Critical Expertise Component Score: ${expertiseScore}`} data-for="component-score-tooltip">
              <div className="component-icon">{getIcon('lightbulb')}</div>
              <div className="progress-bar">
                <div className={`progress tier-${expertiseTier}-bg`} style={{width: `${expertiseScore}%`}}></div>
              </div>
            </div>
            <div className="component-score" data-tip={`Coachability Component Score: ${coachabilityScore}`} data-for="component-score-tooltip">
              <div className="component-icon">{getIcon('coachability')}</div>
              <div className="progress-bar">
                <div className={`progress tier-${coachabilityTier}-bg`} style={{width: `${coachabilityScore}%`}}></div>
              </div>
            </div>
          </div>
        }
        <div className="actions">
          <button onClick={() => { this.toggleDetailsForItem(item); }} className="button grey-outline button-tiny">{detailsToggledOn ? 'Collapse' : 'Show Details'}</button>
        </div>

        {detailsToggledOn &&
          <div className="score-details">
            <ReviewSnapshot
              isOwnReview={false}
              sellerInfo={this.userData(item.sellerId)}
              review={item.currentReview}
              priorReview={item.priorReview}
            />
          <Link to={`/people/${item.sellerId}/salesCompetencies/view/${item.currentReview._id}`} target="_blank" className="view-full-report">View Full Report</Link>
          </div>
        }

        {/*<div className="component-scores">
          <div className="component-score">
            <div className={`dial tier-${competencyTier} medium-small-ring`} style={{width: '50px', height: '50px'}}>
              <div className="dial__progress" data-percent={competencyScore}></div>
              <div className="dial__content" style={{lineHeight: '38px', fontSize: '16px'}}>{competencyScore}</div>
            </div>
          </div>
          <div className="component-score">
            <div className={`dial tier-${expertiseTier} medium-small-ring`} style={{width: '50px', height: '50px'}}>
              <div className="dial__progress" data-percent={expertiseScore}></div>
              <div className="dial__content" style={{lineHeight: '38px', fontSize: '16px'}}>{expertiseScore}</div>
            </div>
          </div>
          <div className="component-score">
            <div className={`dial tier-${coachabilityTier} medium-small-ring`} style={{width: '50px', height: '50px'}}>
              <div className="dial__progress" data-percent={coachabilityScore}></div>
              <div className="dial__content" style={{lineHeight: '38px', fontSize: '16px'}}>{coachabilityScore}</div>
            </div>
          </div>
        </div>*/}
      </div>
    )
  }

  renderReportContent(){
    return (
      <div className="report-content">
        <ReactTooltip id="component-score-tooltip" place="top" offset={{left: '42px', top: '-15px'}} effect="solid" />
        {_.map(this.filteredAndSortedReviews(), this.renderReportItem.bind(this))}
      </div>
    )
  }

  render(){

    const {
      loadingPredictiveSkillsReviewItems,
      loadingPredictiveSkillsReviews,
    } = this.props;

    if(loadingPredictiveSkillsReviewItems || loadingPredictiveSkillsReviews){
      return 'Loading...';
    }

    return (
      <div className="report strengths">
        <div className="content-wrapper">
          <div className="page-main-content">
            <div className="page-title no-subheader">
              <h1>{this.getReportName()}</h1>
            </div>
            <div className="page-actions">
              <div className="select-group">
                {this.renderTeamSelect()}
                {this.renderOrderBySelect()}
              </div>
            </div>
            <div className="page-content">
              {this.renderReportContent()}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    organization: state.organization.data,
    teams: state.teams.data,

    loadingPredictiveSkillsReviews: state.salesCompetencyReviews.loading,
    salesCompetencyReviews: state.salesCompetencyReviews.data,

    salesCompetencyReviewItems: state.salesCompetencyReviewItems.items,
    loadingPredictiveSkillsReviewItems: state.salesCompetencyReviewItems.loading,
    scoredCriticalExpertiseItems: ScoredCriticalExpertiseItemsSelector(state),
  }
}

export default connect(mapStateToProps, { fetchSalesCompetencyReviewItems, fetchUserDataForEveryone, fetchAllSalesCompetencyReviews })(StrengthsReport);



// WEBPACK FOOTER //
// ./src/components/reports/strengths.js